import type { DocumentTypeRef } from '@/document-types/domain/types/DocumentType';

export const QUOTE_DOCUMENT_TYPE_REF = {
  applicationKey: 'crm',
  moduleKey: 'quotes',
  documentTypeKey: 'quote'
} as const satisfies DocumentTypeRef;
